export default __webpack_public_path__ + "static/media/Gallery7.c5485395.webp";